<template>
  <div class="container">
    <categoryTitle title="关注我们" />
    <div class="about-content" v-html="htmlContent"></div>
    <!-- <van-loading size="24px" color="#0094ff" text-color="#0094ff" vertical>
      文章正在加载中...
    </van-loading> -->
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { getreport, reportinfo } from './helper/api';
import categoryTitle from './components/category/category-title.vue';
// import { Loading as VanLoading, Toast } from 'vant';
import { Toast } from 'vant';

const htmlContent = ref();

async function getServiceData() {
  try {
    const { list } = await getreport({ page: 1, size: 1, type: 100 });
    const { content } = await reportinfo(list[0].id);
    htmlContent.value = content;
  } catch (error) {
    Toast.fail('获取文章信息失败');
  }
}
getServiceData();
</script>

<style lang="scss" scoped>
.about-content {
  font-size: 30px;
  line-height: 1.5;
  padding: 0 40px;
  word-break: break-all;
  ::v-deep(a) {
    color: #3b80dd;
  }
  ::v-deep(.grid-table) {
    margin-top: 20px;
    td {
      box-sizing: border-box;
      padding: 30px 5px;
      img {
        margin-bottom: 10px;
      }
      a {
        color: #28292d;
        &:hover {
          color: #3b80dd;
        }
      }
    }
  }
}
</style>
